<!-- Agregado de item personalizado -->
 
 <template>
  <div class="pt-2 space-y-4">
    <h3 class="text-slate-800 dark:text-slate-200 text-md font-semibold">Item Custom</h3>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" for="custom-service-name">Nombre del Item</label>
        <input
          id="custom-service-name"
          v-model="customItem.name"
          type="text"
          placeholder="Ej. Compra de templates"
          class="form-control dark:bg-slate-700 dark:border-slate-600 dark:text-slate-100 dark:placeholder-slate-400"
          required
        />
      </div>
      <div>
        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" for="custom-service-hours">Horas</label>
        <input
          id="custom-service-hours"
          v-model.number="customItem.hours"
          type="number"
          placeholder="e.g., 20"
          min="0.1"
          step="0.1"
          class="form-control dark:bg-slate-700 dark:border-slate-600 dark:text-slate-100 dark:placeholder-slate-400"
          required
        />
      </div>
    </div>
    
    <!-- Supervision Only Checkbox -->
    <div class="flex items-center gap-2">
      <input
        id="supervision-only-custom"
        v-model="supervisionOnlyCustom"
        type="checkbox"
        class="form-checkbox h-4 w-4 text-orange-600 focus:ring-orange-500 border-slate-300 dark:border-slate-600 rounded"
      />
      <label for="supervision-only-custom" class="text-sm font-medium text-slate-700 dark:text-slate-300 flex items-center gap-1">
        <span class="w-1.5 h-1.5 bg-orange-500 rounded-full"></span>
        Solo Supervisión
        <span class="text-xs text-slate-500 dark:text-slate-400">(No incluido en subtotal)</span>
      </label>
    </div>
    
    <button @click="addCustomItem" class="w-full flex items-center justify-center gap-2 rounded-lg h-11 px-4 bg-orange-100 dark:bg-orange-900/30 hover:bg-orange-200 dark:hover:bg-orange-800/50 text-orange-700 dark:text-orange-300 text-sm font-semibold transition-colors border border-orange-200 dark:border-orange-700">
      <i class="material-icons text-lg">add</i>
      <span>Agregar item personalizado</span>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customItem: {
        name: "",
        quantity: 1,
        hours: 0,
      },
      supervisionOnlyCustom: false
    };
  },
  methods: {
    addCustomItem() {
      // Validate before adding
      if (!this.customItem.name || this.customItem.name.trim() === "") {
        alert("Por favor ingrese un nombre para el item");
        return;
      }
      if (!this.customItem.hours || this.customItem.hours <= 0) {
        alert("Por favor ingrese un número de horas válido (mayor a 0)");
        return;
      }
      
      this.$emit("custom-item-added", { ...this.customItem }, this.supervisionOnlyCustom);
      this.customItem = { name: "", quantity: 1, hours: 0 };
      this.supervisionOnlyCustom = false;
    },
  },
};
</script>